import { LogInFormFields } from './LogInForm.types';

export const performLogIn = async ({ username, password }: LogInFormFields) =>
  fetch('/d/mvc/authenticate/login', {
    body: JSON.stringify({ username, password }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });
